"use strict";
exports.__esModule = true;
exports.signupTracer = void 0;
function signupTracer(referrer) {
    if (typeof window !== "undefined") {
        // grab the current page path from the url
        var pagePath_1 = window.location.pathname;
        if (pagePath_1) {
            document.addEventListener("click", function (e) {
                var _a;
                var origin = (_a = e.target) === null || _a === void 0 ? void 0 : _a.closest("a");
                if (origin) {
                    var href = origin.href;
                    if (href.includes("studio.apollographql.com/signup") ||
                        href.includes("studio.apollographql.com/welcome") ||
                        href.includes("studio.apollographql.com/login")) {
                        // set referringPath cookie for 30 days
                        setCookie("referringPath", pagePath_1, 30);
                        // set referrer cookie if no referrer param exists on url
                        if (!href.includes("referrer=")) {
                            setCookie("referrer", referrer, 30);
                        }
                    }
                }
            });
        }
    }
}
exports.signupTracer = signupTracer;
function setCookie(cName, cValue, expDays) {
    var domain = window.location.hostname.includes("apollographql.com")
        ? "domain=apollographql.com;"
        : "";
    var date = new Date();
    date.setTime(date.getTime() + expDays * 24 * 60 * 60 * 1000);
    var expires = "expires=" + date.toUTCString();
    document.cookie = "".concat(cName, "=").concat(cValue, "; ").concat(expires, "; path=/; ").concat(domain);
}
